import { Box, Grid, Typography, Button } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import summer from "../../../../assets/summercamp.png";
import yoga from "../../../../assets/yoga.png";
import dance from "../../../../assets/Dance.png";
import indoorgames from "../../../../assets/indoorgames.png";
import swimming from "../../../../assets/swimming.png";
import SummerPopUp from "./SummerPopUp";

const images = [yoga, dance, indoorgames, swimming];

const SummerCamp = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [openPopUp, setOpenPopUp] = useState(false);
  const contentRef = useRef(null); // Ref to measure content height

  const handlePopUpClose = () => {
    setOpenPopUp(false);
  };

  const handlePopUpOpen = () => {
    setOpenPopUp(true);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  // Get the content height dynamically
  const contentHeight = contentRef.current
    ? contentRef.current.offsetHeight
    : "auto";

  return (
    <motion.div
      style={{
        position: "relative",
        height: contentHeight, // Use dynamic height here
        backgroundColor: "transparent",
        overflow: "hidden",
      }}
    >
      {/* Background Image Layer */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100vw",
          height: contentHeight, // Set background height to match content
          backgroundImage: `url(${summer})`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          zIndex: -1,
          filter: "brightness(0.9)",
        }}
      />

      <Grid
        id="summer"
        container
        sx={{
          px: { xs: 2, md: 5 },
          py: { xs: 5, md: 5 },
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1,
        }}
        ref={contentRef} // Attach the ref to measure the content height
      >
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <Typography
              sx={{
                fontSize: { xs: 20, md: 50 },
                fontWeight: "bold",
                textAlign: "center",
                mb: 4,
                color: "#fff",
                textShadow: "4px 4px 15px rgba(0, 0, 0, 0.7)",
                letterSpacing: "2px",
                fontFamily: "'Comic Sans MS', cursive",
                padding: "10px",
              }}
            >
              🌞 Summer Camp at Podar Juniors! 🌞
            </Typography>
          </motion.div>
        </Grid>

        {/* Animated Image Carousel */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: "flex", justifyContent: "center", mt: 2 }}
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.5, ease: "easeInOut" }}
          >
            <Box
              sx={{
                width: { xs: 300, md: 500 },
                height: { xs: 270, md: 500 },
                overflow: "hidden",
              }}
            >
              <motion.div
                key={currentIndex}
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.8, opacity: 0 }}
                transition={{ duration: 0.8 }}
                style={{ width: "100%", height: "100%" }}
              >
                <img
                  src={images[currentIndex]}
                  alt={`activity-${currentIndex}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                />
              </motion.div>
            </Box>
          </motion.div>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography
            sx={{
              color: "black",
              fontSize: { xs: 16, md: 20 },
              lineHeight: 1.6,
              textAlign: "justify",
              mt: { xs: 2, md: -2 },
            }}
          >
            Looking for an exciting and enriching summer experience for your
            child? Podar Juniors is hosting a fun-filled Summer Camp
            packed with engaging activities that promote learning, creativity,
            and physical fitness!
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
              mt: 2,
              mb: 2,
              fontSize: { xs: 20, md: 25 },
              color: "black",
            }}
          >
            Exciting Activities Include:
          </Typography>
          <Box>
            {[
              "Yoga - Enhance flexibility, concentration, and relaxation.",
              "Indoor Play Area - Safe and interactive space for fun and learning.",
              "Swimming Classes - Build confidence in water with expert guidance.",
              "Dancing Classes - Express creativity through movement and rhythm.",
            ].map((item, index) => (
              <Typography
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: { xs: 16, md: 18 },
                  color: "black",
                  marginBottom: "8px",
                }}
              >
                <span
                  style={{
                    color: "#4caf50",
                    marginRight: "8px",
                    fontSize: "20px",
                  }}
                >
                  ✅
                </span>
                {item}
              </Typography>
            ))}
          </Box>
          <Box sx={{ marginTop: "20px" }}>
            <Typography
              sx={{ fontSize: { xs: 16, md: 20 }, color: "black", mt: 2 }}
            >
              🚌 FREE Transport Available
            </Typography>
            <Typography sx={{ fontSize: { xs: 16, md: 20 }, color: "black" }}>
              🎥 Live CCTV Access for Parents
            </Typography>
            <Typography sx={{ fontSize: { xs: 16, md: 20 }, color: "black" }}>
              📞 Contact Us: 9844565757
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: 16, md: 20 },
                fontWeight: "bold",
                color: "red",
                mt: 2,
                animation: "blink 1000ms infinite",
                "@keyframes blink": {
                  "0%": { color: "red" },
                  "50%": { color: "white" },
                  "75%": { color: "white" },
                  "100%": { color: "red" },
                },
              }}
            >
              📅 Limited Seats Available! Enroll Now!
            </Typography>
          </Box>
        </Grid>
        <Box>
          <Button
            onClick={handlePopUpOpen}
            sx={{
              backgroundColor: "#155a8a",
              color: "#fff",
              mt: 5,
              width: 200,
              height: { xs: 50, md: 70 },
              fontWeight: "bold",
              fontSize: { xs: "12px", md: "20px" },
              padding: { xs: "5px 10px", md: "8px 16px" },
              "&:hover": {
                backgroundColor: "#fdc800",
              },
            }}
          >
            APPLY NOW
          </Button>
        </Box>
        <SummerPopUp
          open={openPopUp}
          onClose={handlePopUpClose}
          isApplyButton={true}
        />
      </Grid>
    </motion.div>
  );
};

export default SummerCamp;

